<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <promo-code-report-table></promo-code-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import PromoCodeReportTable from './PromoCodeReportTable.vue'

  export default {
    name: 'promo-code-report',
    components: {PromoCodeReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/promotion/promoCode/PromoCodeReport.vue